import { Modal } from "@renderbus/ui";
import { ModalProps } from "antd";
import { DeleteProjectModalStyle, Title, DeleteProjectWrapper } from "./atom";
import { useTranslation } from "react-i18next";
import WarnningIcon from "@/pages/child-customer/icons/warning";

export function DeleteProjectModal({
  open,
  projectName,
  modalProps,
}: {
  open: boolean;
  projectName: string;
  modalProps: ModalProps;
}) {
  const { t } = useTranslation("center");

  return (
    <>
      <Modal
        open={open}
        className="renderbus-ui--modal delete-project"
        children={
          <DeleteProjectWrapper>
            <Title>
              <WarnningIcon />
              <span>{t("user_export_list_confirm_del_tips")}</span>
            </Title>
            <p>
              {t("user_com_childPro_son_del_render_span", { 0: projectName })}
            </p>
            <p>{t("user_com_childPro_son_del_render_text")}</p>
          </DeleteProjectWrapper>
        }
        {...modalProps}
      />
      <DeleteProjectModalStyle />
    </>
  );
}
